module.exports = __webpack_public_path__ + "static/media/currency.3b9caf1b.svg";